<template>
  <SelectItem
    class="relative flex select-none items-center rounded-[3px] pl-[25px] pr-[35px] text-[13px] leading-none data-[disabled]:pointer-events-none data-[highlighted]:cursor-pointer data-[highlighted]:bg-theme-placeholder-bg data-[highlighted]:outline-none"
    :class="[withIcon ? 'h-[36px]' : 'h-[25px]', showBackgroundIndicator && 'bg-theme-6']"
    :value="option.key"
  >
    <div class="flex items-center gap-2">
      <img v-if="withIcon && option.src" :src="option.src" class="h-4 w-6 object-contain" />

      <span>{{ option.label }}</span>
    </div>

    <svg
      v-if="isSelected && !useBackgroundIndicator"
      class="absolute left-0 inline-flex w-[25px] items-center justify-center"
      width="11"
      height="9"
      viewBox="0 0 11 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.61047 9L0 5.40347L1.64535 3.76448L3.61047 5.7278L9.35465 0L11 1.639L3.61047 9Z" fill="#FF5470" />
    </svg>
  </SelectItem>
</template>

<script setup lang="ts">
import { SelectItem } from "radix-vue";
import { computed, PropType } from "vue";

interface Option {
  key: string;
  label: string;
  src?: string;
}

const props = defineProps({
  option: { type: Object as PropType<Option>, required: true },
  isSelected: { type: Boolean, default: false },
  useBackgroundIndicator: { type: Boolean, default: false },
});

const withIcon = computed(() => !!props.option.src);
const showBackgroundIndicator = computed(() => props.useBackgroundIndicator && props.isSelected);
</script>
